class MegaMenuPanelSource extends HTMLElement {
  observer;
  pendingAttachment = false;

  connectedCallback() {
    this.attachPanel();

    const headerMenu = this.closest('header-menu');
    if (!(headerMenu instanceof HTMLElement)) return;

    this.observer = new MutationObserver(() => {
      if (this.pendingAttachment) return;
      this.pendingAttachment = true;
      queueMicrotask(() => {
        this.pendingAttachment = false;
        this.attachPanel();
      });
    });
    this.observer.observe(headerMenu, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  attachPanel() {
    const template = this.querySelector('template[data-mega-menu-panel]');
    const headerMenu = this.closest('header-menu');
    if (!(template instanceof HTMLTemplateElement) || !(headerMenu instanceof HTMLElement)) return;

    const menuHandle = template.dataset.menuHandle;
    this.groupMobileDrawer(template, menuHandle);
    const grid = Array.from(headerMenu.querySelectorAll('.mega-menu__grid')).find(
      (candidate) => candidate instanceof HTMLElement && candidate.dataset.menuHandle === menuHandle
    );
    if (!(grid instanceof HTMLElement)) return;

    if (template.dataset.layout === 'cards') {
      this.groupLinks(grid, [
        template.getAttribute('data-heading-1'),
        template.getAttribute('data-heading-2'),
        template.getAttribute('data-heading-3'),
        template.getAttribute('data-heading-4'),
      ]);
    }

    const panelId = template.dataset.panelId;
    if (panelId && grid.querySelector(`:scope > .mega-menu__promotions[data-mega-panel-id="${CSS.escape(panelId)}"]`)) {
      return;
    }

    grid.querySelectorAll(':scope > .mega-menu__promotions').forEach((promotion) => promotion.remove());
    const content = template.content.cloneNode(true);
    if (!(content instanceof DocumentFragment)) return;

    const parentHref = grid.closest('.menu-list__list-item')?.querySelector(':scope > .menu-list__trigger > a')?.getAttribute('href');
    content.querySelectorAll('[data-use-parent-link]').forEach((link) => {
      if (parentHref) link.setAttribute('href', parentHref);
    });
    grid.append(content);
  }

  groupLinks(grid, headings) {
    const list = grid.querySelector(':scope > .mega-menu__list');
    if (!(list instanceof HTMLUListElement) || list.classList.contains('mega-menu__list--grouped')) return;

    const links = Array.from(list.querySelectorAll('.mega-menu__column > div > .mega-menu__link'));
    const normalizedHeadings = headings.filter(Boolean).map((heading) => heading.trim().toLocaleLowerCase());
    const flow = document.createElement('li');
    flow.className = 'mega-menu__grouped-flow';
    let column;

    links.forEach((sourceLink) => {
      const link = sourceLink.cloneNode(true);
      if (!(link instanceof HTMLElement)) return;
      const text = link.textContent?.trim() ?? '';
      const wrap = link.querySelector('.wrap-text');
      if (wrap) wrap.replaceWith(document.createTextNode(text));
      const isHeading = normalizedHeadings.includes(text.toLocaleLowerCase());
      if (isHeading || !column) {
        column = document.createElement('div');
        column.className = 'mega-menu__grouped-column';
        flow.append(column);
      }
      if (isHeading) {
        link.classList.add('mega-menu__link--parent', 'mega-menu__link--column-heading');
      }
      column.append(link);

      const childList = sourceLink.nextElementSibling;
      if (childList instanceof HTMLUListElement) {
        childList.querySelectorAll(':scope > li > .mega-menu__link').forEach((childLink) => {
          column.append(childLink.cloneNode(true));
        });
      }
    });

    list.replaceChildren(flow);
    list.className = 'mega-menu__list mega-menu__list--grouped list-unstyled';
    list.setAttribute('role', 'list');
  }

  groupMobileDrawer(template, menuHandle) {
    if (!menuHandle || template.dataset.layout !== 'cards') return;

    const details = document.getElementById(`Details-menu-drawer-${menuHandle}`);
    const list = details?.querySelector(':scope > .menu-drawer__menu--childlist');
    if (!(list instanceof HTMLUListElement)) return;

    const headings = [
      template.getAttribute('data-heading-1'),
      template.getAttribute('data-heading-2'),
      template.getAttribute('data-heading-3'),
    ]
      .filter(Boolean)
      .map((heading) => heading.trim().toLocaleLowerCase());
    const cta = template.getAttribute('data-heading-4')?.trim().toLocaleLowerCase();

    Array.from(list.children).forEach((listItem) => {
      if (!(listItem instanceof HTMLLIElement)) return;
      const item = listItem.querySelector(':scope > .menu-drawer__menu-item');
      if (!(item instanceof HTMLElement)) return;
      const text = item.textContent?.trim().toLocaleLowerCase() ?? '';

      if (headings.includes(text)) {
        listItem.classList.add('menu-drawer__list-item--group-heading');
        item.classList.add('menu-drawer__menu-item--group-heading');

        if (item instanceof HTMLAnchorElement) {
          const label = document.createElement('span');
          label.className = item.className;
          label.replaceChildren(...item.childNodes);
          item.replaceWith(label);
        }
      } else if (cta && text === cta) {
        listItem.classList.add('menu-drawer__list-item--group-cta');
        item.classList.add('menu-drawer__menu-item--group-cta');
      }
    });
  }
}

if (!customElements.get('crosley-mega-menu-panel')) {
  customElements.define('crosley-mega-menu-panel', MegaMenuPanelSource);
}
